import { useMutation } from "@tanstack/react-query";

import {
    updateAutoTopupSettings,
} from "../services/payments";

export function useUpdateAutoTopupSettings() {

    return useMutation({

        mutationFn:
            updateAutoTopupSettings,

    });

}